module.exports = "/_next/static/images/rolex_model_background_grey_landscape-a3862605ee471912ec6b1e6d8dcc046a.jpg";